import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import helpers from "./shared/layouts/helpers";

const languageList = {"no": "Norwegian", "se": "Swedish", "en": "English", "fi": "Finnish"}

// Danish is no longer offered, so anyone set to it gets Norwegian.
const retiredLanguages = ["da"];
i18n.on("languageChanged", (lng) => {
    if (retiredLanguages.includes(lng)) {
        i18n.changeLanguage("no");
    }
});

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: false,
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false
        },
    });

export default i18n;